import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@material-ui/core';
import FormField from 'components/@common/Inputs/FormField';
import { Organization, OrganizationRole } from 'types/schema-generated-types';
import OrganizationRolesPicker from '../../../components/OrganizationRolesPicker';

interface EditUserFormProps {
  organizations?: Organization[];
  organizationRoles: OrganizationRole[];
}

const EditUserForm = (props: EditUserFormProps) => {
  const { t } = useTranslation();
  const { organizations, organizationRoles } = props;

  return (
    <Grid container>
      <Grid item>
        <FormField disabled name="email" label={t('E-mail Address', { ns: '@common' })} />
        <FormField disabled name="pin" label={t('Educator PIN', { ns: '@common' })} />
        <OrganizationRolesPicker
          organizations={organizations}
          organizationRoles={organizationRoles}
        />
      </Grid>
    </Grid>
  );
};

export default EditUserForm;
